import React from 'react';
import img1 from '../../assets/images/jeep-1.jpg';
import img2 from '../../assets/images/jeep-2.jpg';
import img3 from '../../assets/images/jeep.jpg';

const About = () => {
    return (
      <div className="grid md:grid-cols-3 gap-8 m-8">
        <img className="h-[300px] object-cover" src={img1} alt="" />
        <img className="h-[300px] object-cover" src={img2} alt="" />
        <img className="h-[300px] object-cover" src={img3} alt="" />
      </div>
    );
};

export default About;